export type ActiveRequestInit = RequestInit & {
  /** Explicit original-authority reads are limited to role options and authentication. */
  roleView?: 'original' | string;
};

/** Intentional authentication control flow, not a network or authorization failure. */
export class RoleViewSwitchInProgressError extends Error {
  readonly code = 'ROLE_VIEW_SWITCH_IN_PROGRESS';
  constructor() {
    super('正在切换验收角色，请等待权限重新读取后操作。');
    this.name = 'RoleViewSwitchInProgressError';
  }
}

/** One dispatch owner shared by all business clients of this active session. */
export function createRoleViewDispatch() {
  let selectedRoleId: string | null = null;
  let switching = false;
  return {
    get selectedRoleId() {
      return selectedRoleId;
    },
    select(roleId: string | null) {
      selectedRoleId = roleId;
    },
    setSwitching(value: boolean) {
      switching = value;
    },
    headers(path: string, init: ActiveRequestInit): Headers {
      const headers = new Headers(init.headers);
      headers.delete('x-cpq-role-view');
      const original =
        init.roleView === 'original' ||
        path.startsWith('/auth/') ||
        path === '/healthz' ||
        path === '/readyz' ||
        path.startsWith('/public/');
      if (switching && !original && path !== '/me')
        throw new RoleViewSwitchInProgressError();
      const roleId = original ? null : (init.roleView ?? selectedRoleId);
      if (roleId) headers.set('x-cpq-role-view', roleId);
      return headers;
    },
  };
}
